/*SYSTEM IMPORTS*/
import React from 'react'

import './style'
import './media'

/*Ui*/
import Cont from 'components/ui/Cont'
import ListPhotos from 'components/ui/ListPhotos'
import PhotoItem from 'components/ui/PhotoItem'

/*HELPERS*/
import {Helpers} from "api";
import AppCore from 'cores/AppCore'

/*VIEW*/
import Modal from "components/Modal";
import Img from "components/Img";
import { IsIsset } from "helpers/ValueTests";
import ControlLeftGray from './images/control-left-gray.svg'
// import ControlLeftGray from './images/control-left-gray.png'
import ControlRightGray from './images/control-right-gray.svg'


const ContPhotos = ({
     id,
     value: { slide = [],
     title = AppCore.Interfaces.t( "DoctorLanding.Ui.ContPhotosV2.Index.Title" )
     } }) => {
    const [open, setOpen] = React.useState( false )
    const [link, setLink] = React.useState( "" )
    const [text, setText] = React.useState( "" )

    const openModal = (id) => {
        const file = slide.find( item => item.id == id )

        setLink( `${Helpers.GetImage(file.image[0], "full")}` )

        if(file.text){
            setText( file.text )
        } else {
            setText( "" )
        }

        setOpen( id )
    }

    const nextIMG = () => {
        if ( slide.length > open ) {
            const file = slide.find(item => item.id === open+1)

            setLink(`${Helpers.GetImage(file.image[0], "full")}`)

            if (file.text) {
                setText(file.text)
            } else {
                setText( "" )
            }

            setOpen(open+1)
        }
    }

    const prevIMG = () => {
        if (open > 1) {
            const file = slide.find(item => item.id == open-1)

            setLink(`${Helpers.GetImage(file.image[0], "full")}`)

            if (file.text) {
                setText(file.text)
            } else {
                setText( "" )
            }

            setOpen(open-1)
        }
    }

    const closeModal = () => {
        setOpen( false )
        setLink( "" )
    }

    let main_title = AppCore.Interfaces.t( "DoctorLanding.Ui.ContPhotosV2.Index.Title" )

    if(IsIsset(title)) {
        main_title = title
    }

    return(
        <>
            {slide.length > 0 &&
            <Cont id={`block-${id}`} className="cont-photos">
                <h2>
                    { main_title }
                </h2>
                <ListPhotos>
                    { slide.sort((a,b) => (a.id-b.id)).map( item => (
                        <PhotoItem
                            key={ item.id }
                            id={ item.id }
                            image_id={item.image[0]}
                            onClick={ openModal }
                            image={
                                <Img src={Helpers.GetImage(item.image[0], "253_251")} externals div/>
                            }
                            title={item.text}
                        />
                    ))}
                </ListPhotos>
                <Modal className="modal-photo-item"
                    isOpen={!!open}
                    onRequestClose={closeModal}
                >
                    <div className="photo-wrapper">
                        <div onClick={prevIMG} className='arrow left-arrow'>
                            <Img src={ControlRightGray} />
                        </div>
                        <Img src={link} externals/>
                        <div onClick={nextIMG} className='arrow right-arrow'>
                            <Img src={ControlLeftGray} />
                        </div>
                    </div>
                    <div className="modal-photo-item__title">{text}</div>
                </Modal>
            </Cont>
            }
        </>

    )
}

export default ContPhotos